import { timeFormat } from '@/utils'

export default function () {
  return [
    {
      title: '帮扶党组织名称',
      [$field]: 'orgName',
    },
    {
      title: '帮扶申请时间',
      [$field]: 'careTime',
      render: (h, {row}) => {
        return h('span', timeFormat(row.careTime))
      }
    },
    {
      title: '帮扶金额',
      [$field]: 'careAmount'
    },
    {
      title: '帮扶证明材料',
      [$field]: 'careFile',
      render: (h, {row}) => {
        return h('span', {
          class: 'iv-pointer iv-hover-color iv-m-b-12',
          on: {
            'click': function () {
              let url = `api-uum/file/downloadFile?fileId=${row.careFileId}` + '&access_token=' + sessionStorage.getItem('token')
              const openPage = window.open
              openPage(url)
              openPage.opener = null
            }
          }
        }, row.careFile)
      }
    }
  ]
}
